import { useDisclosure, Box, Button } from '@cad-arc';
import { MonitoredEntitiesDrawer } from './monitored-entities-drawer';

export function MonitoredEntitiesButton(): React.ReactElement {
    const { isOpen, onClose, onToggle } = useDisclosure();
    return (
        <Box ml="10">
            <Button
                isActive={isOpen}
                leadingVisual="BulletedList"
                type="button"
                size="sm"
                variant="outline"
                onClick={() => {
                    onToggle();
                }}
            >
                Monitored Events
            </Button>
            <MonitoredEntitiesDrawer isOpen={isOpen} onClose={onClose} />
        </Box>
    );
}
